import React from 'react';
import { Provider as StoreProvider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CustomThemeProvider } from './custom-theme-provider';
import { SnackbarProvider } from 'notistack';
import { store } from '../../store';
import { apolloClient } from '../../../services';
import { ErrorBoundary } from '../error-boundary/error-boundary';

interface ProvidersProps {
    children: React.ReactNode[] | React.ReactNode;
}

// Ordered outer → inner by dependency: state/data providers depend on nothing,
// routing next, and the UI layer (theme/localization/snackbar) last — the theme
// must wrap SnackbarProvider and the date pickers.
export const Providers = ({ children }: ProvidersProps) => {
    return (
        <ErrorBoundary>
            {/* state + data */}
            <StoreProvider store={store}>
                <ApolloProvider client={apolloClient}>
                    {/* routing */}
                    <Router>
                        {/* UI */}
                        <CustomThemeProvider>
                            <LocalizationProvider
                                dateAdapter={AdapterDayjs}
                                adapterLocale="es"
                            >
                                <SnackbarProvider
                                    maxSnack={6}
                                    anchorOrigin={{
                                        horizontal: 'left',
                                        vertical: 'bottom',
                                    }}
                                >
                                    {children}
                                </SnackbarProvider>
                            </LocalizationProvider>
                        </CustomThemeProvider>
                    </Router>
                </ApolloProvider>
            </StoreProvider>
        </ErrorBoundary>
    );
};
